// Vendor imports
import '@fancyapps/ui'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import resize from '@alpinejs/resize'
import intersect from '@alpinejs/intersect'
import breakpoint from 'alpinejs-breakpoints'
Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(resize)
window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
    '3xl',
    'max',
    'wide',
]

// Stores (must register before Alpine.start)
import './modules/utm-tracking'

import './modules/lazysizes-config'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/alpine-directives'
import './modules/accordion'
import './modules/animations'
import './modules/btn-morph'
import './modules/dialog'
import './modules/fancyapps'
import './modules/filters'
import './modules/google-maps'
import './modules/hero-intro'
import './modules/svgIconSprite'
import './modules/swiper'
import './modules/video-fit'
import './modules/donation-stripe'
import './modules/donation-products'
import './modules/donation-suggestion-amount'
import './modules/donation-analytics'
import './modules/formie'
import './modules/donation-page-tabs'

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
        window.Alpine.start()
    }, 100)
})
